import {ReactElement} from "react"

export namespace IWarnings {
	export class Warning {
		id: string | number = self.crypto.randomUUID();
		message: WarningMessage  = ""

		constructor(message: WarningMessage) {
			this.message = message
		}
	}

	export type WarningMessage = string | ReactElement

	export type WarningsProps = {
		warnings: Warning[],
		loading?: boolean,
	}
}